import { StylovyzeIconProps } from '@innovyze/stylovyze';
import React from 'react';

const RiskIconLarge: React.FC<StylovyzeIconProps> = ({
	color,
	...props
}: StylovyzeIconProps) => {
	return (
		<svg
			width="77"
			height="77"
			viewBox="0 0 77 77"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M38.7017 55.6144L58.8548 32.5981L36.0658 52.9531C34.92 52.6862 33.6691 52.9943 32.7774 53.8948C31.3987 55.2881 31.3995 57.543 32.7774 58.9355C34.1561 60.3279 36.3897 60.3279 37.7684 58.9355C38.6609 58.0349 38.9668 56.7716 38.7017 55.6144Z"
				fill="#007CA0"
			/>
			<path
				d="M60.9823 34.9517L57.2791 39.1804C60.9431 43.9415 63.1328 49.9143 63.1328 56.3973H68.6226C68.6226 48.2471 65.7546 40.7756 60.9823 34.9517Z"
				fill="#007CA0"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M39.1053 28.5424C44.0453 29.2307 48.5737 31.2358 52.3371 34.1891L56.5243 30.4491C50.8417 25.7013 43.5752 22.8194 35.6439 22.7363L39.1053 28.5424ZM18.1912 34.2218H10.2131C5.07461 40.1444 1.96021 47.903 1.96021 56.3967H7.45002C7.45002 47.3976 11.658 39.372 18.1912 34.2218Z"
				fill="#007CA0"
			/>
			<path
				d="M19.4079 22.6306H16.4111V25.6567H19.4079V22.6306Z"
				fill="#007CA0"
			/>
			<path
				d="M19.4079 12.0376H16.4111V21.1175H19.4079V12.0376Z"
				fill="#007CA0"
			/>
			<path
				d="M35.5634 30.7502H0.404053L17.985 0L35.5634 30.7502ZM5.59526 27.7233H30.3714L17.985 6.05303L5.59526 27.7233Z"
				fill="#007CA0"
			/>
		</svg>
	);
};

export default RiskIconLarge;
